import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoading: false,
  errors: null,
  data: {}
};

export const slice = createSlice({
  name: 'aemContent',
  initialState,
  reducers: {
    setInitialState: (state, { payload }) => {
      state.data[payload] = initialState.data;
    },
    setIsLoading: (state, { payload }) => {
      state.data[payload].isLoading = true;
    },
    setSuccess: (state, { payload }) => {
      state.data[payload.id] = payload;
      state.data[payload.id].isLoading = false;
    }
  }
});

export const { setInitialState, setIsLoading, setSuccess } = slice.actions;

export const selectSlice = (state) => state[slice.name];
export const selectData = (state) => selectSlice(state).data;

export const selectDataByJourney = (pageId) => (state) =>
  selectData(state)[pageId];

export default slice.reducer;
